import { Delete, Group, ArrowBack } from "@material-ui/icons";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import fetchClient from "../../api/fetchClient";
import Loader from "../../components/Loader";
import message from "../../helper/message";

function AplicacaoAribaGroups() {
  const history = useHistory();
  const [empresas, setEmpresas] = useState([]);
  const [isViewing, setIsViewing] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState("");
  const [editandoGrupo, setEditandoGrupo] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    getAllAplicacoes();
  }, [isViewing]);

  const getAllAplicacoes = async () => {
    try {
      setIsLoading(true);
      const { data } = await fetchClient.get("/ariba/getAllGroups");
      setEmpresas(data);
    } catch (error) {
      message.error(error.response?.data?.message || "Erro ao buscar grupos");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateGroup = async () => {
    try {
      if (!newGroupName.trim()) {
        return message.error("Informe o nome do grupo");
      }

      const payload = {
        id: newGroupName.trim(),
      };

      await fetchClient.post("/ariba/groups", payload);
      message.sucess("Grupo criado com sucesso!");

      setShowModal(false);
      setEditandoGrupo(null);
      setNewGroupName("");
      getAllAplicacoes();
    } catch (error) {
      message.error(error.response?.data?.message || "Erro ao salvar grupo");
    }
  };

  const onDelete = async (id) => {
    const confirmar = window.confirm("Deseja realmente excluir este grupo?");
    if (!confirmar) return;

    try {
      setDeletingId(id);
      await fetchClient.delete(`/ariba/groups/${id}`);
      message.sucess("Grupo deletado com sucesso");
      getAllAplicacoes();
    } catch (error) {
      message.error(error.response?.data?.message || "Erro ao deletar grupo");
    } finally {
      setDeletingId(null);
    }
  };

  if (isLoading) return <Loader />;

  return (
    <Container>
      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <ModalTitle>
              {editandoGrupo ? "Editar Grupo" : "Novo Grupo"}
            </ModalTitle>
            <StyledInput
              type="text"
              placeholder="Nome do grupo"
              value={newGroupName}
              disabled={editandoGrupo?.id}
              onChange={(e) => setNewGroupName(e.target.value)}
            />

            <ModalActions>
              <CancelButton
                onClick={() => {
                  setShowModal(false);
                  setEditandoGrupo(null);
                  setNewGroupName("");
                }}
              >
                Cancelar
              </CancelButton>
              <SaveButton onClick={handleCreateGroup}>Salvar</SaveButton>
            </ModalActions>
          </ModalContent>
        </ModalOverlay>
      )}

      <PageContent>
        <ModernHeader>
          <HeaderLeft>
            <BackButton onClick={() => history.goBack()}>
              <ArrowBack />
            </BackButton>
            <HeaderContent>
              <Title>
                <Group style={{ marginRight: "12px", fontSize: "32px" }} />
                Grupos Ariba
              </Title>
              <Subtitle>Gerencie os grupos de aplicações Ariba</Subtitle>
            </HeaderContent>
          </HeaderLeft>
          <HeaderActions>
            <NewButton
              onClick={() => {
                setShowModal(true);
                setEditandoGrupo(null);
                setNewGroupName("");
              }}
            >
              <PersonAddIcon style={{ marginRight: "8px" }} />
              Novo Grupo
            </NewButton>
          </HeaderActions>
        </ModernHeader>
        <CardsContainer>
        {empresas.map((aplicacao, index) => (
          <Card key={aplicacao.id} index={index}>
            <CardHeader>
              <CardTitle>{aplicacao.id}</CardTitle>
              <TypeBadge>GRUPO</TypeBadge>
            </CardHeader>

            <CardBody>
              <InfoRow>
                <InfoIcon>
                  <Group />
                </InfoIcon>
                <InfoText>
                  <InfoLabel>Nome do Grupo</InfoLabel>
                  <InfoValue>{aplicacao.id}</InfoValue>
                </InfoText>
              </InfoRow>
            </CardBody>

            <CardFooter>
              <ActionButtonsRow>
                <EditButton
                  onClick={() => {
                    setEditandoGrupo(aplicacao);
                    setNewGroupName(aplicacao.id);
                    setShowModal(true);
                  }}
                >
                  ✏️ Editar
                </EditButton>
                <DeleteButtonStyled onClick={() => onDelete(aplicacao.id)}>
                  {deletingId === aplicacao.id ? (
                    <LoaderMini />
                  ) : (
                    <>
                      <Delete style={{ marginRight: "4px" }} /> Deletar
                    </>
                  )}
                </DeleteButtonStyled>
              </ActionButtonsRow>
            </CardFooter>
          </Card>
        ))}
        </CardsContainer>
      </PageContent>
    </Container>
  );
}

export default AplicacaoAribaGroups;
  
// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const spin = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  background-color: #f3f4f6;
  font-family: "Mulish", sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;
`;

const PageContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
  padding: 3rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-family: "Mulish", sans-serif;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 12px;
`;

const NewButton = styled.button`
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(230, 126, 34, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(230, 126, 34, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  animation: ${fadeIn} 0.8s ease;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.6s ease;
  animation-delay: ${(props) => props.index * 0.1}s;
  animation-fill-mode: both;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }
`;

const CardHeader = styled.div`
  padding: 24px;
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0;
`;

const TypeBadge = styled.span`
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CardBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const InfoIcon = styled.div`
  color: #e67e22;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(230, 126, 34, 0.1);
  border-radius: 10px;
  flex-shrink: 0;
`;

const InfoText = styled.div`
  flex: 1;
`;

const InfoLabel = styled.div`
  font-size: 12px;
  color: #95a5a6;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
  word-break: break-word;
`;

const CardFooter = styled.div`
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #ecf0f1;
`;

const ActionButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const EditButton = styled.button`
  flex: 1;
  background: white;
  color: #f39c12;
  border: 2px solid #f39c12;
  border-radius: 10px;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #f39c12;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(243, 156, 18, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const DeleteButtonStyled = styled.button`
  flex: 1;
  background: white;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  border-radius: 10px;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #e74c3c;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
  background: white;
  padding: 32px;
  border-radius: 16px;
  width: 100%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.3s ease;
`;

const ModalTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 20px 0;
  font-family: "Mulish", sans-serif;
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`;

const CancelButton = styled.button`
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  background: #ecf0f1;
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;

  &:hover {
    background: #bdc3c7;
  }
`;

const SaveButton = styled.button`
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(230, 126, 34, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(230, 126, 34, 0.4);
  }
`;

const StyledInput = styled.input`
  padding: 14px;
  font-size: 14px;
  border: 2px solid #ecf0f1;
  border-radius: 10px;
  width: 100%;
  outline: none;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  font-family: "Mulish", sans-serif;
  box-sizing: border-box;

  &:focus {
    border-color: #e67e22;
    box-shadow: 0 0 0 3px rgba(230, 126, 34, 0.1);
  }

  &:disabled {
    background: #f8f9fa;
    cursor: not-allowed;
  }
`;

const LoaderMini = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid white;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

const BackButton = styled.button`
  background: rgba(230, 126, 34, 0.1);
  border: none;
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #e67e22;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(230, 126, 34, 0.2);
    transform: translateX(-4px);
  }

  &:active {
    transform: translateX(0);
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const ModernHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: ${fadeIn} 0.6s ease;
  margin-bottom: 2.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;
